"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoHttpVerbsInPaths = void 0;

var utils_1 = require("../../utils");

var httpMethods = ['get', 'head', 'post', 'put', 'patch', 'delete', 'options', 'trace'];

var NoHttpVerbsInPaths = function NoHttpVerbsInPaths(_ref) {
  var splitIntoWords = _ref.splitIntoWords;
  return {
    PathItem: function PathItem(_path, _ref2) {
      var key = _ref2.key,
          report = _ref2.report,
          location = _ref2.location;
      var pathKey = key.toString();
      if (!pathKey.startsWith('/')) return;
      var pathSegments = pathKey.split('/');

      var _iterator = _createForOfIteratorHelper(pathSegments),
          _step;

      try {
        var _loop = function _loop() {
          var pathSegment = _step.value;
          if (!pathSegment || utils_1.isPathParameter(pathSegment)) return "continue";

          var isHttpMethodIncluded = function isHttpMethodIncluded(method) {
            return splitIntoWords ? utils_1.splitCamelCaseIntoWords(pathSegment).has(method) : pathSegment.toLocaleLowerCase().includes(method);
          };

          var _iterator2 = _createForOfIteratorHelper(httpMethods),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var method = _step2.value;

              if (isHttpMethodIncluded(method)) {
                report({
                  message: "path `".concat(pathKey, "` should not contain http verb ").concat(method),
                  location: location.key()
                });
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  };
};

exports.NoHttpVerbsInPaths = NoHttpVerbsInPaths;